import { v4 as uuid } from 'uuid'

export const generateId = (prefix?: string) => {
  if (prefix) {
    return `${prefix}-${uuid()}`
  }

  return uuid()
}
